import { render, staticRenderFns } from "./SimilarTravellers.vue?vue&type=template&id=231e875d&"
import script from "./SimilarTravellers.vue?vue&type=script&lang=js&"
export * from "./SimilarTravellers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports